{
  "share_configs.setup.title": "微信分享接入检查",
  "share_configs.setup.check": "重新检查网站",
  "share_configs.setup.configuration": "后台配置",
  "share_configs.setup.website": "网站接通",
  "share_configs.setup.checked_at": "检测时间",
  "share_configs.setup.valid": "配置有效",
  "share_configs.setup.incomplete": "配置待补充",
  "share_configs.setup.connected": "服务器检测通过",
  "share_configs.setup.pending": "待处理",
  "share_configs.setup.passed": "通过",
  "share_configs.setup.recommended": "建议的独立回调地址（不会自动替换）",
  "share_configs.setup.team_id": "Apple Team ID（10 位字母或数字）",
  "share_configs.setup.app_id_prefix": "App ID Prefix（留空时使用 Team ID）",
  "share_configs.setup.hosting_mode": "关联文件托管方式",
  "share_configs.setup.managed": "由当前部署托管",
  "share_configs.setup.external": "外部网站，自行部署",
  "share_configs.setup.hosting_help": "只有部署者批准的域名可以自动托管。外部域名需要下载并部署关联文件；选择托管不会自动取得域名权限。",
  "share_configs.setup.apple_help": "在 Apple Developer 的会员信息中找 Team ID，在 Identifiers 中核对 App ID Prefix 与 Bundle ID。旧账号的 Prefix 可能与 Team ID 不同。点击问号查看完整步骤。",
  "share_configs.setup.rebuild": "需要重新打包 · 真机待验证",
  "share_configs.setup.boundary": "检查通过只表示服务器当前可读取关联文件，不代表 Apple CDN 已刷新、微信审核通过或已安装 App 已更新。修改地址后，请同步微信开放平台，再重新导出、打包并安装。",
  "share_configs.setup.external_help": "请下载 AASA 并交给网站维护人员：与已有 applinks、webcredentials 等配置合并，不要覆盖其他 App。",
  "share_configs.setup.download_aasa": "下载 Apple 关联文件",
  "share_configs.setup.download_native": "下载原生配置包",
  "share_configs.setup.export_failed": "导出失败。请先补齐 Apple 身份、启用绑定并使用以 / 结尾的独立 HTTPS 回调路径，再重试。",
  "share_configs.setup.import_help": "请将配置包交给负责打包的人。在项目根目录运行下方命令，并提供启用平台的 --ios-bundle-id、--android-package、--android-signature、--harmony-bundle-name 参数（或对应 AK_* 环境变量）。运行相同命令加 --check 可只读检查漂移。此文件只含公开构建参数，不含证书或密码。",
  "share_configs.setup.checks.apple_identity": "Apple 关联身份完整",
  "share_configs.setup.checks.callback_path": "独立回调路径有效",
  "share_configs.setup.checks.hosting": "托管权限或外部部署方式有效",
  "share_configs.setup.checks.aasa_https": "HTTPS 直接返回 200（无跳转）",
  "share_configs.setup.checks.aasa_json": "AASA 为有效 JSON 且不超过 128 KB",
  "share_configs.setup.checks.aasa_identity": "关联文件包含正确的 Prefix.Bundle ID",
  "share_configs.setup.checks.aasa_path": "关联规则覆盖回调目录及子路径",
  "share_configs.guide.steps.apply.title": "申请微信移动应用",
  "share_configs.guide.steps.apply.description": "在微信开放平台登录后，进入管理中心 → 移动应用 → 创建移动应用。按页面提交主体、图标、介绍、隐私政策和平台信息，等待审核。不是公众号 AppID，也不是小程序 AppID。",
  "share_configs.guide.steps.apply.done": "完成判断：应用显示审核通过，并取得以 wx 开头的移动应用 AppID。",
  "share_configs.guide.steps.apple.title": "核对 Apple 身份并开启权限",
  "share_configs.guide.steps.apple.description": "在 Apple Developer → Account → Membership details 找到 Team ID。进入 Certificates, Identifiers & Profiles → Identifiers，打开对应 Bundle ID，记录 App ID Prefix，勾选 Associated Domains 后保存。没有权限时请联系账号持有人。",
  "share_configs.guide.steps.apple.done": "完成判断：Bundle ID 与打包项目一致，Associated Domains 已启用。后台不能代替你开启 Apple 权限。",
  "share_configs.guide.steps.configure.title": "在后台保存并绑定 App",
  "share_configs.guide.steps.configure.description": "在系统 → 系统设置 → 分享配置填写微信 AppID、Apple 身份、Bundle ID 和 Universal Link，选择托管方式并启用。再到 App 管理 → 应用管理 → 客户端配置 → 分享配置选择并保存。接入检查会提供独立回调地址；如采用它，请返回分享配置修改，然后把同一完整地址（包括最后的 /）填到微信开放平台该移动应用的 iOS Universal Link。",
  "share_configs.guide.steps.configure.done": "完成判断：后台配置有效，后台与微信开放平台的 Universal Link 完全相同。原有地址不会自动改变。",
  "share_configs.guide.steps.website.title": "检查网站关联文件",
  "share_configs.guide.steps.website.description": "在 App 分享配置中点击重新检查网站。托管域名会由后台自动生成文件；若提示无托管权限，请联系部署者。外部域名请下载 Apple 关联文件，交给网站维护人员合并已有 AASA，并放到 HTTPS 域名的 /.well-known/apple-app-site-association，文件无扩展名、无需登录、不能跳转，Content-Type 使用 application/json。",
  "share_configs.guide.steps.website.done": "完成判断：HTTPS、JSON、身份和路径检查均通过。Apple CDN 可能仍有缓存，服务器检查通过不能证明手机已完成关联。",
  "share_configs.guide.steps.profile.title": "重新下载 Apple 描述文件",
  "share_configs.guide.steps.profile.description": "开启权限后，到 Apple Developer → Profiles，编辑当前 iOS App Development 描述文件，核对 App ID、证书和测试手机，重新生成并下载 .mobileprovision。交给打包人员替换项目 AK_IOS_DEV_PROFILE 对应文件。正式发行需更新对应发行描述文件。不要上传证书私钥或密码到分享配置。",
  "share_configs.guide.steps.profile.done": "完成判断：描述文件的 application-identifier 与 Prefix.Bundle ID 一致，并包含 com.apple.developer.associated-domains。旧描述文件不会自动更新。",
  "share_configs.guide.steps.rebuild.title": "导入原生配置并重新打包安装",
  "share_configs.guide.steps.rebuild.description": "下载原生配置包，将其交给打包人员，按接入检查下方命令导入项目并核对原生身份。iOS/Android 微信 Provider 需要 HBuilderX 5.08 或更高版本。重新制作自定义基座或正式包并安装到手机，不能只热更新页面。项目打包检查会核对描述文件、Provider 和关联域；若报错请按提示修复再打包。",
  "share_configs.guide.steps.rebuild.done": "完成判断：新包已安装，Provider 检测包含 weixin。后台无法替你签发描述文件、完成微信审核或在手机上安装 App。",
  "share_configs.guide.steps.verify.title": "在装有微信的真机验证",
  "share_configs.guide.steps.verify.description": "打开新安装的 App → 任意资讯详情 → 分享，分别测试微信好友、朋友圈和收藏，并到微信查看实际结果。再测试取消分享、未安装微信和失败降级。若仍弹出系统分享，先确认使用的是新包；需要排查时，在我的 → 帮助与关于连续点击版本号 7 次开启调试模式。",
  "share_configs.guide.steps.verify.done": "完成判断：三个场景均在真实手机和微信中验证。编译成功、模拟器或系统分享可用不能代替微信直分享验收。",
  "share_configs.guide.links.appleAccount": "Apple 开发者账户",
  "share_configs.guide.links.appleIdentifiers": "App ID 与权限",
  "share_configs.guide.links.appleProfiles": "描述文件管理",
  "share_configs.guide.links.associatedDomains": "Apple 关联域说明",
  "share_configs.title": "分享配置",
  "share_configs.description": "集中维护可复用的平台身份，再由每个 App 选择并导出到原生工程。",
  "share_configs.actions.create": "新建配置",
  "share_configs.actions.edit": "编辑",
  "share_configs.actions.activate": "启用",
  "share_configs.actions.disable": "停用",
  "share_configs.actions.delete": "删除",
  "share_configs.actions.save_draft": "保存草稿",
  "share_configs.actions.bind": "分享配置",
  "share_configs.actions.preflight": "执行预检",
  "share_configs.actions.remove_binding": "解除绑定",
  "share_configs.filters.query": "搜索名称或 AppID",
  "share_configs.filters.provider": "平台",
  "share_configs.filters.status": "状态",
  "share_configs.columns.name": "配置名称",
  "share_configs.columns.provider": "平台",
  "share_configs.columns.app_id": "平台 AppID",
  "share_configs.columns.status": "状态",
  "share_configs.columns.bindings": "已绑定 App",
  "share_configs.columns.updated_at": "更新时间",
  "share_configs.columns.actions": "操作",
  "share_configs.provider.wechat": "微信",
  "share_configs.status.draft": "草稿",
  "share_configs.status.active": "已启用",
  "share_configs.status.disabled": "已停用",
  "share_configs.empty": "暂无分享配置",
  "share_configs.editor.create_title": "新建分享配置",
  "share_configs.editor.edit_title": "编辑分享配置",
  "share_configs.editor.basic": "基本信息",
  "share_configs.editor.android": "Android",
  "share_configs.editor.ios": "iOS",
  "share_configs.editor.harmony": "HarmonyOS",
  "share_configs.editor.readiness": "启用检查",
  "share_configs.fields.name": "配置名称",
  "share_configs.fields.description": "配置描述",
  "share_configs.fields.provider": "分享平台",
  "share_configs.fields.external_app_id": "微信 AppID",
  "share_configs.fields.platform_enabled": "启用该平台",
  "share_configs.fields.android_package": "Android 包名",
  "share_configs.fields.android_signature": "Android 应用签名",
  "share_configs.fields.ios_bundle_id": "iOS Bundle ID",
  "share_configs.fields.ios_universal_link": "iOS Universal Link",
  "share_configs.fields.harmony_bundle_name": "Harmony Bundle Name",
  "share_configs.help.app_secret": "微信分享不需要 AppSecret，本系统不会收集或下发 AppSecret。",
  "share_configs.help.rebuild": "后台保存不会改变已安装 App；绑定后仍需重新导出并打包。",
  "share_configs.confirm.activate": "启用前会校验所有已勾选平台的原生身份。",
  "share_configs.confirm.disable": "停用后，所有已绑定 App 将立即回退到系统分享。",
  "share_configs.confirm.delete": "仅未被 App 绑定的配置可以删除。",
  "share_configs.guide.trigger": "查看微信开放平台申请指引",
  "share_configs.guide.title": "如何申请微信分享 AppID？",
  "share_configs.guide.welcome": "第一次配置也没关系",
  "share_configs.guide.intro": "按照下面 7 步完成申请、网站接通和手机验证。后台会自动完成可托管的部分；Apple 权限、描述文件、重新打包及手机安装需要你按指引继续操作。",
  "share_configs.guide.actions.got_it": "我知道了",
  "share_configs.guide.steps.account.title": "1. 注册微信开放平台账号",
  "share_configs.guide.steps.account.description": "使用组织主体账号登录微信开放平台，并按平台提示完成开发者资质认证。平台规则可能调整，请以申请页面的最新要求为准。",
  "share_configs.guide.steps.account.requirement.subject": "准备企业或组织主体资料，以及管理员身份与联系方式。",
  "share_configs.guide.steps.account.requirement.materials": "提前准备应用名称、图标、简介、官方网站和隐私政策等资料。",
  "share_configs.guide.steps.application.title": "2. 创建移动应用",
  "share_configs.guide.steps.application.description": "进入“管理中心 → 移动应用 → 创建移动应用”，按实际发布平台登记应用。",
  "share_configs.guide.steps.application.requirement.profile": "应用名称、图标和功能介绍应与准备上架的 App 保持一致。",
  "share_configs.guide.steps.application.requirement.consistency": "不要使用临时包名或测试 Bundle ID；微信会校验安装包的原生身份。",
  "share_configs.guide.steps.identity.title": "3. 填写三端原生身份",
  "share_configs.guide.steps.identity.description": "只填写实际启用的平台，并从用于正式打包的工程或签名产物中复制标识。",
  "share_configs.guide.steps.identity.requirement.android": "Android：填写正式包名和发布证书对应的应用签名。",
  "share_configs.guide.steps.identity.requirement.ios": "iOS：填写 Bundle ID 和可通过 HTTPS 访问的 Universal Link，并正确部署 Associated Domains。",
  "share_configs.guide.steps.identity.requirement.harmony": "HarmonyOS：填写与正式应用一致的 Bundle Name，并按微信官方接入指南准备签名身份。",
  "share_configs.guide.steps.review.title": "4. 提交审核并记录 AppID",
  "share_configs.guide.steps.review.description": "确认资料和原生身份无误后提交审核。审核通过后，在移动应用详情中复制以 wx 开头的 AppID。",
  "share_configs.guide.steps.review.requirement.submit": "审核状态、补充材料和处理时效以微信开放平台页面显示为准。",
  "share_configs.guide.steps.review.requirement.app_id": "请保存 AppID；分享配置不需要填写 AppSecret，也不要把 AppSecret 放进客户端。",
  "share_configs.guide.steps.appkernia.title": "5. 回到应核完成配置和打包",
  "share_configs.guide.steps.appkernia.description": "获得 AppID 后，在本页完成配置，再将它绑定到目标 App。",
  "share_configs.guide.steps.appkernia.requirement.configure": "填写 AppID，启用需要的平台并保存草稿；确认无误后启用配置。",
  "share_configs.guide.steps.appkernia.requirement.build": "到“App 管理 → 操作 → 分享配置”完成绑定和预检，然后重新导出并打包。",
  "share_configs.guide.steps.appkernia.requirement.verify": "使用已安装微信的真机验证好友、朋友圈和收藏场景；编译成功不等于真机分享通过。",
  "share_configs.guide.links.openPlatform": "打开微信开放平台",
  "share_configs.guide.links.applicationCenter": "前往移动应用管理中心",
  "share_configs.guide.links.createApplication": "查看创建移动应用指引",
  "share_configs.guide.links.androidAccess": "Android 官方接入指引",
  "share_configs.guide.links.iosAccess": "iOS 官方接入指引",
  "share_configs.guide.links.harmonyAccess": "HarmonyOS 官方接入指引",
  "share_configs.guide.links.sharing": "查看分享与收藏文档",
  "share_configs.guide.links.dcloudModule": "查看 uni-share 构建配置",
  "share_configs.guide.checklist.title": "提交前快速检查",
  "share_configs.guide.checklist.approved": "微信移动应用已经审核通过，并取得正确的 AppID。",
  "share_configs.guide.checklist.identity": "包名、应用签名、Bundle ID 和 Bundle Name 与正式构建完全一致。",
  "share_configs.guide.checklist.universal_link": "iOS Universal Link 使用 HTTPS，相关域名和 Associated Domains 已正确配置。",
  "share_configs.guide.checklist.device": "配置绑定后已经重新打包，并准备安装微信的真机进行验收。",
  "share_configs.guide.secret.title": "请勿在这里填写 AppSecret",
  "share_configs.guide.secret.description": "微信内容分享只需要 AppID 和各端原生身份。AppSecret 属于服务端敏感凭据，本系统的分享配置不会收集、保存或下发它。",
  "share_configs.feedback.saved": "分享配置已保存",
  "share_configs.feedback.activated": "分享配置已启用",
  "share_configs.feedback.disabled": "分享配置已停用",
  "share_configs.feedback.deleted": "分享配置已删除",
  "share_configs.feedback.bound": "App 分享配置已绑定",
  "share_configs.feedback.unbound": "App 分享绑定已移除",
  "share_configs.feedback.error": "操作失败，请检查输入或刷新后重试",
  "share_configs.binding.title": "App 分享配置",
  "share_configs.binding.description": "同一 App 在每个平台只能绑定一条当前配置。",
  "share_configs.binding.config": "有效配置",
  "share_configs.binding.scenes": "允许场景",
  "share_configs.binding.share_origin": "HTTPS 分享落地域名",
  "share_configs.binding.fallback": "失败降级",
  "share_configs.binding.fallback_system": "系统分享",
  "share_configs.binding.enabled": "启用绑定",
  "share_configs.binding.scene_session": "微信好友",
  "share_configs.binding.scene_timeline": "朋友圈",
  "share_configs.binding.scene_favorite": "微信收藏",
  "share_configs.binding.no_active_config": "请先在系统设置中启用一条微信分享配置。",
  "share_configs.binding.preflight_ready": "预检通过，可以导出构建配置",
  "share_configs.binding.preflight_failed": "预检未通过，请修正配置",
  "share_configs.binding.build_pending": "待重新导出并打包",
  "share_configs.binding.system_fallback": "直分享不可用时使用系统分享",
  "share_configs.binding.issue_config_not_active": "分享配置未启用",
  "share_configs.binding.issue_config_invalid": "分享配置内容无效",
  "share_configs.binding.issue_platform_incomplete": "已启用平台的原生身份不完整",
  "share_configs.binding.issue_origin_invalid": "分享落地域名必须是安全的 HTTPS 来源",
  "share_configs.binding.issue_unknown": "预检返回未知问题，请刷新后重试"
}
